import getParameterFromURL from './getParameterFromURL';

// Тема первого экрана определяется тегом в названии креатива (utm_content).
// Креатив без тега -> general.
export const START_PAGE_THEME_TAGS = [
  { tag: '_BIT_', theme: 'bite' },
  { tag: '_CRT_', theme: 'crate' },
  { tag: '_POT_', theme: 'potty' },
];

export default function getStartPageTheme(): string {
  const adName = (getParameterFromURL('utm_content') || '').toUpperCase();
  const matched = START_PAGE_THEME_TAGS.find(({ tag }) => adName.includes(tag));

  return matched ? matched.theme : 'general';
}

// Конфиги, у которых первый экран зависит от темы. Только для них в аналитику
// уходит first_screen — у остальных воронок этого измерения просто нет.
const THEMED_START_PAGE_CONFIGS = ['customV77'];

// Значения для аналитики и для платёжной страницы (ключи — темы выше).
const FIRST_SCREEN_VALUES: Record<string, string> = {
  general: 'general',
  bite: 'stop_biting',
  crate: 'crate_training',
  potty: 'potty_training',
};

// null — конфиг без тематического первого экрана: параметр не добавляем вовсе.
export function getFirstScreenTag(): string | null {
  const config = getParameterFromURL('config');
  if (!config || THEMED_START_PAGE_CONFIGS.indexOf(config) < 0) return null;

  return FIRST_SCREEN_VALUES[getStartPageTheme()] || null;
}
